import React, { useEffect } from "react";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { locationMasterSingleListAsync } from "../../../../redux/features/location-master/singleListLocationMasterSlice";
import { locationMasterUpdateAsync } from "../../../../redux/features/location-master/updateLocationMasterSlice";
import { useParams } from "react-router-dom";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const LocationSchema = Yup.object().shape({
   personName: Yup.string()
      .min(3, "Too Short!")
      .max(50, "Too Long!")
      .required("Person name is required"),
});

export default function LocationMasterEdit() {
   const { id } = useParams();
   const dispatch = useDispatch();
   const navigate = useNavigate();

   useEffect(() => {
      if (id) {
         dispatch(backdropLoadingAction(true));
         dispatch(
            locationMasterSingleListAsync({
               data: { id: id, modelId: 1, actionId: 3 },
               done: (location) => {
                  formik.setFieldValue("personName", location?.name);
                  dispatch(backdropLoadingAction(false));
               },
               err: () => {
                  dispatch(backdropLoadingAction(false));
               },
            })
         );
      }
   }, [id]);

   const formik = useFormik({
      initialValues: {
         personName: "",
      },
      validationSchema: LocationSchema,
      onSubmit: (values) => {
         dispatch(backdropLoadingAction(true));
         const updateData = {
            name: values.personName,
            model_id: "10",
            action_id: "2",
            id: id,
         };
         dispatch(
            locationMasterUpdateAsync({
               data: updateData,
               done: () => {
                  dispatch(backdropLoadingAction(false));
                  toast.success("Location updated successfully.");
                  navigate(-1);
               },
               err: () => {
                  dispatch(backdropLoadingAction(false));
                  toast.error("Failed to update location.");
               },
            })
         );
      },
   });

   const { getFieldProps, handleSubmit, resetForm, touched, errors } = formik;

   return (
      <div>
         <BodyHeader title="Edit Location Master" />
         <div className="p-3 shadow-lg">
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary">
                     <div className="card-header">
                        <h3 className="card-title">Location Master Details</h3>
                     </div>
                     <div className="card-body">
                        <div className="row">
                           <div className="col-12 col-sm-12 col-md-6">
                              <CustomInput
                                 require
                                 label="Name"
                                 id="personName"
                                 placeholder="Enter Person Name"
                                 {...getFieldProps("personName")}
                                 errors={touched.personName && errors.personName}
                                 message={errors.personName}
                              />
                           </div>
                           <div className="col-lg-12 mt-3 text-center">
                              <button
                                 className="btn btn-primary px-4 py-3"
                                 type="submit"
                                 onClick={handleSubmit}
                              >
                                 <h6 className="mb-0 text-uppercase">Update</h6>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
